import React, { useEffect, useState } from 'react'
import {
   Edit,
   SimpleForm,
   TextInput,
   NumberInput, SelectArrayInput,
} from 'react-admin'

import { transform } from '../../../../helpers'
import { BackButton } from '../../../helperComponents/BackButton'
import { httpClient } from '../../../../config'
import { CustomEditToolbar } from '../../../helperComponents/CustomEditToolbar';
import { useIndustry } from '../../../../context/IndustryContext'

export const TopBrandsSettingsEdit = props => {
   const [reports, setReports] = useState([])
   const { industryId } = useIndustry()

   useEffect(() => {
      try {
         const doRequest = async () => {
            const response = await httpClient(`/tables/reference_fields/report_names?industry_id=${industryId}`)
            const fetchedReports = JSON.parse(response.body) || []

            setReports(fetchedReports)
         }

         doRequest()
      } catch (err) {
         console.log(err)
      }
   }, [industryId])

   return (
     <>
        <BackButton path="/top_brand_settings"/>
        <span className="h4">Edit top brand</span>
        <Edit {...props} title=" " transform={transform('report_ids')}>
           <SimpleForm toolbar={<CustomEditToolbar />}>
              <TextInput source="id" label="ID"/>
              <NumberInput source="affiliate_id" label="Affiliate IDs"/>
              <NumberInput source="offer_id" label="Offer ID"/>
              <TextInput source="top_brand" label="Top Brand"/>
              <SelectArrayInput source="report_ids"
                                label="Report IDs"
                                choices={reports.map(({id, report_name}) => ({id, name: `${report_name} - ${id}`}))}
              />
           </SimpleForm>
        </Edit>
     </>
   )
}